// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3qhY0","col":"styles_col__24sJH"};